import * as React from 'react';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

const activeIngredientList = (props) => {

	return (
		<DataTable
			value={props.activeIngredients}
			paginator={true}
			lazy={true}
			rows={props.rows}
			totalRecords={props.totalRecords}
			onPage={(event) => props.onPageClick(event)}
			first={props.first}
		>
			<Column field="activeIngredientName" header="Name" />
			<Column field="genericINNName" header="Generic INN Name" />
			<Column field="commonChemicalName" header="Common Chemical Name" />
			<Column field="molecularFormula" header="Molecular Formula" />
			{/* <Column field="iupacChemicalName" header="IUPAC Chemical Name" /> */}
			<Column
				header="Actions"
				style={{ textAlign: "center", width: "8em" }}
				body={(rowData, column) =>
					<div>
						<Button
							type="button"
							icon="pi pi-pencil"
							className="p-button-warning"
							tooltip="Edit"
							tooltipOptions={{ position: 'top' }}
							style={{ marginRight: ".5em" }}
							onClick={() => props.editClick(rowData.activeIngredientId)}
						/>
						<Button
							type="button"
							icon="pi pi-trash"
							className="p-button-danger"
							tooltip="Delete"
							tooltipOptions={{ position: 'top' }}
							onClick={() => props.deleteClick(rowData.activeIngredientId)}
						/>
					</div>
				}
			/>
		</DataTable>
	)
}

export default activeIngredientList;
